import { useContext, useEffect, useState } from "react";
import { requester } from "App";
import { useParams } from "react-router-dom";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VendorStockList from "routes/vendor/storemanage/pages/VendorStockList";
import style from "routes/vendor/storemanage/pages/VendorStoreStock.module.css"

function Partnersitemstock({ store }) {
    const { storeId } = useParams();
    const [isMounted, setMounted] = useState(false);
    const [items, setItems] = useState([]);
    const [editingItemId, setEditingItemId] = useState(null);
    const [newQuantity, setNewQuantity] = useState("");
    const fontSize = 'max(1.2vw, 10px)';

    useEffect(() => {
        setMounted(true);
        getStock()
    }, []);

    const getStock = async () => {
        console.log("hey store", store)
        let data = {
            storeCode: store.storeCode
        };
        await requester.findAllVendorProducts(data, (result) => {
            setItems(result.data);
        });
    };

    const updateQuantity = async (itemId, quantity) => {
        let data = { id: itemId, quantity: parseInt(quantity) };
        await requester.updateStoreProductQuantity(data, (result) => {
            if (result.data) {
                getStock();
                setEditingItemId(null);
                setNewQuantity("");
            }
        });
    }

    const handleSubmit = (itemId) => {
        if (newQuantity && !isNaN(newQuantity) && parseInt(newQuantity) >= 0) {
            updateQuantity(itemId, newQuantity);
        }
    };

    const cancelEdit = () => {
        setEditingItemId(null);
        setNewQuantity("");
    };

    return (
        <div>
            <VerticalFlex
                backgroundColor="white"
                padding="max(1vw, 10px)"
                borderRadius="1rem"
            >
                <FlexChild alignItems="flex-start">
                    <P size="max(1.4vw, 10px)" padding="0 0 1rem" weight={700}>
                        {store.storeName}
                    </P>
                </FlexChild>
                <HorizontalFlex padding="0 0 1rem" gap="1rem">
                    <FlexChild>
                        <VerticalFlex
                            backgroundColor="white"
                            padding="max(1vw, 10px)"
                            borderRadius="1rem"
                        >
                            <FlexChild alignItems="flex-start">
                                <div
                                    style={{
                                        borderBottom: "1px solid #D9D9D9",
                                    }}
                                >
                                    <HorizontalFlex padding="0 0 1rem" gap="1rem">
                                        <FlexChild>
                                            <P color={"#626D7D"} size={fontSize} weight={700}>
                                                제품이름
                                            </P>
                                        </FlexChild>
                                        <FlexChild justifyContent="flex-end">
                                            <P color={"#626D7D"} size={fontSize} weight={700}>
                                                재고
                                            </P>
                                        </FlexChild>
                                        <FlexChild justifyContent="flex-end">
                                            <P color={"#626D7D"} size={fontSize} weight={700}>
                                                재고 관리
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </div>
                                <div>
                                    {items.map((item, index) => (
                                        <HorizontalFlex padding="1em 0" gap="1em" key={item.id}>
                                            <FlexChild>
                                                <VerticalFlex>
                                                    <FlexChild alignItems="flex-start">
                                                        <P size={fontSize}>
                                                            {item.productName}
                                                        </P>
                                                    </FlexChild>
                                                </VerticalFlex>
                                            </FlexChild>
                                            <FlexChild>
                                                <VerticalFlex>
                                                    <FlexChild justifyContent="flex-end" alignItems="flex-start">

                                                        {editingItemId === item.id ? (
                                                            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', justifyContent : "flex-end" }}>
                                                                <input
                                                                    type="number"
                                                                    value={newQuantity}
                                                                    onChange={(e) => setNewQuantity(e.target.value)}
                                                                    style={{
                                                                        width: '60px',
                                                                        padding: '0.25rem',
                                                                        fontSize: fontSize,
                                                                        border: '2px solid #1E88E5'
                                                                    }}
                                                                    min="0"
                                                                    autoFocus
                                                                />
                                                                <button
                                                                    onClick={() => handleSubmit(item.id)}
                                                                    style={{
                                                                        padding: '0.25rem 0.5rem',
                                                                        fontSize: fontSize,
                                                                        backgroundColor: '#4CAF50',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    확인
                                                                </button>
                                                                <button
                                                                    onClick={cancelEdit}
                                                                    style={{
                                                                        padding: '0.25rem 0.5rem',
                                                                        fontSize: fontSize,
                                                                        backgroundColor: '#f44336',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    취소
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent : "flex-end" }}>
                                                                <P
                                                                    size={fontSize}
                                                                    color={item.quantity < 20 ? "red" : ""}
                                                                >
                                                                    {item.quantity}
                                                                </P>
                                                                {item.quantity < 20 && (
                                                                    <button
                                                                        onClick={() => {
                                                                            setEditingItemId(item.id);
                                                                            setNewQuantity(item.quantity.toString());
                                                                        }}
                                                                        style={{
                                                                            padding: '0.15rem 0.4rem',
                                                                            fontSize: `calc(${fontSize} - 2px)`,
                                                                            backgroundColor: '#1E88E5',
                                                                            color: 'white',
                                                                            border: 'none',
                                                                            borderRadius: '4px',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                    >
                                                                        수정
                                                                    </button>
                                                                )}
                                                            </div>
                                                        )}
                                                    </FlexChild>
                                                </VerticalFlex>
                                            </FlexChild>
                                            <FlexChild justifyContent="flex-end">
                                                {/* <VerticalFlex>
                                                    <FlexChild alignItems="flex-start"> */}
                                                        <P size={fontSize} color={"red"} weight={"bold"}>
                                                            {item.quantity < 20 ? "재고부족" : ""}
                                                        </P>
                                                    {/* </FlexChild>
                                                </VerticalFlex> */}
                                            </FlexChild>
                                        </HorizontalFlex>
                                    ))}
                                </div>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                </HorizontalFlex>
            </VerticalFlex>
        </div>
    );
}
export default Partnersitemstock;